import { render, staticRenderFns } from "./AuthorListPage.vue?vue&type=template&id=3c9c2ad6"
import script from "./AuthorListPage.vue?vue&type=script&lang=js"
export * from "./AuthorListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports